import React from 'react'
import { Button, Progress, Badge} from '@mantine/core'
import { Link } from 'react-router-dom'
import { IconArrowRight } from '@tabler/icons-react'

export default function CourseCard({ id, image, title, days, hours, percentage, type, year, ...others }) {
   const IS_SUBSCRIPTION = type?.toUpperCase() === 'SUSCRIPCION'
   return (
      <div key={id} className="activeCardCourse-column-div" {...others} >
         <div className="activeCardCourse-father-div">
            {!IS_SUBSCRIPTION && <Badge pos='absolute' color='var(--color-tertiary-light)' top={24} right={24}>{year}</Badge>}
            <div className="activeCardCourse-content-div">
               <img style={{ minHeight: IS_SUBSCRIPTION ? "200px" : "unset" }} className="activeCardCourse-img" src={image} alt={title} />
               <div className="activeCardCourse-info-div">
                  <p className="activeCardCourse-course-title">{title}</p>
                  {!IS_SUBSCRIPTION && <p className="activeCardCourse-course-description">{days} <span>{hours}</span></p>}
               </div>
            </div>
         </div>

         {!IS_SUBSCRIPTION && <div className="activeCardCourse-progressBar-div">
            <p className="activeCardCourse-percentage-complete">
               Curso completado en un {percentage}%
            </p>
            <Progress value={percentage} color="#DF3576" />
         </div>}
         <Button
            mt={IS_SUBSCRIPTION ? 20 : 0}
            rightSection={<IconArrowRight />}
            variant='light'
            component={Link}
            color='var(--color-tertiary)'
            to={`/campus/curso/${id}`}
         >Ver más</Button>
      </div>
   )
}
